import apiFetch from '../../apiFetch'

export default function (idControlSemen) {
  return apiFetch({endPoint: `ControlSemen/getControlSemen?idControlSemen=${idControlSemen}`, method: 'GET', body: null})
}
